import {
  TypographyColor,
  TypographyVariant,
} from "../../../constants/typography";
import { Typography } from "../../core/Typography/Typography";
import { FC, HTMLAttributes } from "react";
import { useStyles } from "./VideoCard.style";
import { Time } from "../../../models/time";
import { VideoItem } from "@onmo/graphql/graphql";

export const VideoCard: FC<
  {
    video: VideoItem;
    isPlayingVideo?: boolean;
  } & HTMLAttributes<HTMLDivElement>
> = ({ video, isPlayingVideo, ...otherProps }) => {
  const classes = useStyles();

  const renderVideo = () => {
    if (isPlayingVideo) {
      return (
        <iframe
          className={classes.videoThumbnail}
          src={`https://www.youtube.com/embed/${video.id}?autoplay=1`}
          title="YouTube video"
          allowFullScreen
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
        />
      );
    } else {
      return (
        <img
          src={video.thumbnailUrl.high}
          alt="Video thumbnail"
          className={classes.videoThumbnail}
        />
      );
    }
  };

  return (
    <div {...otherProps}>
      {renderVideo()}
      <div className={classes.videoInfo}>
        <div className={classes.info}>
          <Typography variant={TypographyVariant.BodyB3Bold} lines={1}>
            {video.title}
          </Typography>
          <Typography
            variant={TypographyVariant.BodyB6Regular}
            color={TypographyColor.Silver}
            lines={1}
          >
            {Time.getTimeAgo(video.publishedAt)} - {video.description}
          </Typography>
        </div>
      </div>
    </div>
  );
};

export default VideoCard;
